import React, { useState } from 'react';
import { TrackballControls } from '@react-three/drei';
import NetPlane from './NetPlane';
import { Canvas, useThree } from '@react-three/fiber';
import { useRef, useEffect} from 'react';

function useIsMobile(maxWidth = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= maxWidth);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= maxWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [maxWidth]);

  return isMobile;
}

export default function NetScene({theme}) {
  const controlsRef = useRef();

  function CameraFixer() {
    const { camera } = useThree();
  
    useEffect(() => {
      camera.near = 0.001;
      camera.updateProjectionMatrix(); // force update!
    }, [camera]);
  
    return null;
  }

  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? 
        <div className="home-container">
          <div className="home-text">
            <h1>Home</h1>
            &nbsp;
            <h3>Gradient Hill Shader</h3>
            <p>"the scene below is an image - however, if opened on a desktop, it is interactive and can be clicked and draged to create hills, or rotated using the mouse"</p>
          </div>
          <div className='canvas-wrapper-mobile'>
            <img src={`${process.env.PUBLIC_URL}/images/home-img.png`} alt="shader graphics" />
          </div>
        </div>
        : 
        <div className="home-container">
          <div className="home-text">
            <h1>Home</h1>
            &nbsp;
            <h3>Gradient Hill Shader</h3>
            <p>"the scene is interactive - click and drag to create hills, or rotate the grid using the mouse"</p>
          </div>
  
          <div className="canvas-wrapper">
            <Canvas
              style={{ width: '100%', height: '100%' }}
              camera={{ position: [4.5, 1.5, 3.5], fov: 50, near: 0.001, far: 1000 }}
            >
              <CameraFixer />
              <ambientLight />
              <NetPlane controlsRef={controlsRef} theme={theme} />
              <TrackballControls noZoom={false} noPan={true} ref={controlsRef} />
            </Canvas>
          </div>
        </div>
      }
    </>
  );
}
